import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

export const myElearningAdapter = createEntityAdapter();

export interface MyElearningStateType {
  isSearchOpen: boolean;
  isNewModuleOpen: boolean;
}

const initialState: MyElearningStateType = myElearningAdapter.getInitialState({
  isSearchOpen: false,
  isNewModuleOpen: false,
});

const myElearningSlice = createSlice({
  name: 'myElearning',
  initialState,
  reducers: {
    openSearch: (state) => {
      state.isSearchOpen = true;
    },
    closeSearch: (state) => {
      state.isSearchOpen = false;
    },
    openNewModule: (state) => {
      state.isNewModuleOpen = true;
    },
    closeNewModule: (state) => {
      state.isNewModuleOpen = false;
    },
  },
});

export const { name, actions, reducer } = myElearningSlice;
